import { Col, Divider, Row } from 'antd';
import loginImgHand from '../../assets/img/loginImgHand.png';
import monetos from '../../assets/img/monetos.png';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SmallBanner = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="login-image-small">
      <Row style={{ height: '100%', width: '100%' }}>
        <Col span={6} className="justify-content-start align-items-start" style={{ height: '60%', width: '60%' }}>
          <img src={loginImgHand} alt="" style={{ height: '75%' }} />
        </Col>
        <Col span={12} className="justify-content-center align-items-center">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
              <span className="login-logo-title">{t('banner.top.text')}</span>
            </Col>
            <Col xs={0} sm={0} md={24} lg={24} xl={24} xxl={24}>
              <Divider className="space-vertical-sm" />
            </Col>
            <Col xs={0} sm={0} md={24} lg={24} xl={24} xxl={24}>
              <span className="login-logo-text">{t('banner.bottom.text')}</span>
            </Col>
          </Row>
        </Col>
        <Col span={6} className="justify-content-end align-items-end">
          <img src={monetos} alt="" style={{ width: '130%', maxWidth: 500 }} />
        </Col>
      </Row>
    </div>
  );
};

export default SmallBanner;
